/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ReportingControllerGetReviewUsageQueryResponse, ReportingControllerGetReviewUsageQueryParams, ReportingControllerGetReviewUsage400, ReportingControllerGetReviewUsage401, ReportingControllerGetReviewUsage403, ReportingControllerGetReviewUsage404 } from "../../models/reportingController/ReportingControllerGetReviewUsage";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { reportingControllerGetReviewUsage } from "../../clients/reportingService/reportingControllerGetReviewUsage";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const reportingControllerGetReviewUsageQueryKey = (params: ReportingControllerGetReviewUsageQueryParams) => [{
  url: '/api/v1/reporting/reviews'
}, ...(params ? [params] : [])] as const;
export type ReportingControllerGetReviewUsageQueryKey = ReturnType<typeof reportingControllerGetReviewUsageQueryKey>;
export function reportingControllerGetReviewUsageQueryOptions(params: ReportingControllerGetReviewUsageQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = reportingControllerGetReviewUsageQueryKey(params);
  return queryOptions<ReportingControllerGetReviewUsageQueryResponse, ResponseErrorConfig<ReportingControllerGetReviewUsage400 | ReportingControllerGetReviewUsage401 | ReportingControllerGetReviewUsage403 | ReportingControllerGetReviewUsage404>, ReportingControllerGetReviewUsageQueryResponse, typeof queryKey>({
    enabled: !!params,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return reportingControllerGetReviewUsage(params, config);
    }
  });
}

/**
 * @summary Get review and playbook run counts (document vs project level), most-used templates, a bucketed series, a per-team breakdown and the previous-period comparison for an organization, optionally narrowed to a team and a first-run date range.
 * {@link /api/v1/reporting/reviews}
 */
export function useReportingControllerGetReviewUsage<TData = ReportingControllerGetReviewUsageQueryResponse, TQueryData = ReportingControllerGetReviewUsageQueryResponse, TQueryKey extends QueryKey = ReportingControllerGetReviewUsageQueryKey>(params: ReportingControllerGetReviewUsageQueryParams, options: {
  query?: Partial<QueryObserverOptions<ReportingControllerGetReviewUsageQueryResponse, ResponseErrorConfig<ReportingControllerGetReviewUsage400 | ReportingControllerGetReviewUsage401 | ReportingControllerGetReviewUsage403 | ReportingControllerGetReviewUsage404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? reportingControllerGetReviewUsageQueryKey(params);
  const query = useQuery({
    ...reportingControllerGetReviewUsageQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ReportingControllerGetReviewUsage400 | ReportingControllerGetReviewUsage401 | ReportingControllerGetReviewUsage403 | ReportingControllerGetReviewUsage404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}